'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styles = function styles(theme) {
  return {
    wrapper: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    flex: {
      flex: 1
    },
    titleButton: {
      padding: theme.spacing.unit
    },
    logo: {
      flex: 1,
      cursor: 'pointer',
      height: '45px',
      minWidth: '160px'
    },
    image: {
      height: '100%',
      margin: '0',
      padding: '0'
    },
    links: {
      float: 'right'
    }
  };
};

exports.default = styles;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-layout/lib/templates/AppBar/BasicAppBar/styles.js
// module id = 616
// module chunks = 61549186969478 79611799117203